import { FC, ReactNode } from 'react';

import { Empty } from 'shared/components';
import { Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	className?: string;
	children?: ReactNode;
}

export const ResultsNotSelected: FC<Props> = ({ className, children, ...otherProps }) => {
	return (
		<Empty
			className={styles.empty}
			title={
				<Text component="h2" variant="grotesk/20/medium">
					No filters selected
				</Text>
			}
			icon="empty-list"
			{...otherProps}>
			<Text className={styles.emptyDescription} color="grey" variant="grotesk/16/regular">
				Please choose at least one filter to start searching
			</Text>
		</Empty>
	);
};
